'use strict';

export default {
  default: {
    cron: '0 0 0 * * *',
    limit: 45000,
    xsl: true,
    autoGenerate: false,
  },
  validator() {},
};
